import { useEffect, useState, useCallback } from "react";
import DashboardLayout from "@/components/DashboardLayout";
import TransactionCard from "@/components/TransactionCard";
import { Column } from "@/lib/useTransactions";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

export default function StatusBoard() {
  const { currentStore } = useAuth();
  const [txns, setTxns] = useState([]);

  const load = useCallback(async () => {
    if (!currentStore) return;
    try {
      const { data } = await api.get(`/transactions?store_id=${currentStore.id}&include_delivered=1`);
      setTxns(data.transactions || []);
    } catch { /* ignore */ }
  }, [currentStore]);

  useEffect(() => {
    load();
    const id = setInterval(load, 6000);
    return () => clearInterval(id);
  }, [load]);

  const pick = (s) => txns.filter((t) => t.current_status === s && !t.is_exception);
  const queue = pick("WAITING");
  const preparing = pick("ACCEPTED_BY_WAREHOUSE");
  const ready = pick("PREPARED");
  const serving = pick("SERVICE_STARTED");
  const delivered = txns.filter((t) => t.current_status === "DELIVERED");
  const exceptions = txns.filter((t) => t.is_exception);

  return (
    <DashboardLayout title="Live Status">
      <p className="text-sm text-muted-foreground mb-4">Every request from the moment a customer checks in through to delivery — updates automatically.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-6 gap-4" data-testid="status-board">
        <Column title="In Queue" count={queue.length} accent="#F59E0B" testId="col-status-queue">
          {queue.map((t) => <TransactionCard key={t.id} txn={t} subtitle="Checked in" />)}
        </Column>
        <Column title="Warehouse" count={preparing.length} accent="#3B82F6" testId="col-status-warehouse">
          {preparing.map((t) => <TransactionCard key={t.id} txn={t} assignedName={t.warehouse_accepted_by_name} subtitle="Preparing" />)}
        </Column>
        <Column title="Ready" count={ready.length} accent="#22C55E" testId="col-status-ready">
          {ready.map((t) => <TransactionCard key={t.id} txn={t} subtitle="Prepared" />)}
        </Column>
        <Column title="In Service" count={serving.length} accent="#8B5CF6" testId="col-status-serving">
          {serving.map((t) => <TransactionCard key={t.id} txn={t} assignedName={t.service_started_by_name} subtitle="Serving" />)}
        </Column>
        <Column title="Delivered Today" count={delivered.length} accent="#16A34A" testId="col-status-delivered">
          {delivered.map((t) => <TransactionCard key={t.id} txn={t} assignedName={t.delivered_by_name} subtitle="Delivered" />)}
        </Column>
        <Column title="Attention" count={exceptions.length} accent="#FF3B30" testId="col-status-exceptions">
          {exceptions.map((t) => <TransactionCard key={t.id} txn={t} />)}
        </Column>
      </div>
    </DashboardLayout>
  );
}
